import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';

export default function ConversionFieldChoice(props) {
    const { colClassName, formGroupClassName = '', customControlClassName = '', choiceColClassName = '', field, inputType, path, id, updateChoice } = props;
    const { type, label, choices, required, disabled, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name} ${formGroupClassName}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                <div className="row row--equalized gutters-0">
                    {choices?.map((choice, choiceIndex) => {
                        return (
                            <div key={choice.key} className={`${choiceColClassName}`}>
                                <Form.Check
                                    className={`custom-control custom-${inputType} ${customControlClassName} ${error ? 'is-error' : ''}`}
                                    type={inputType}
                                    id={`${id}.choices.${choiceIndex}-${choice.key}`}
                                >
                                    <Form.Check.Input
                                        type={inputType}
                                        className="custom-control-input"
                                        name={id}
                                        value={choice.key}
                                        {...{
                                            required,
                                            disabled,
                                        }}
                                        checked={value?.includes(choice.key)}
                                        onChange={(e) => {
                                            updateChoice(choice, e.target.checked, () => {
                                                trigger(path);
                                            });
                                        }}
                                    />
                                    <Form.Check.Label className="custom-control-label">
                                        <span className="custom-control-label__title" dangerouslySetInnerHTML={{ __html: choice.label }} />
                                        {choice?.['pay-off'] && (
                                            <span className="custom-control-label__pay-off">{choice?.['pay-off']}</span>
                                        )}
                                        {choice?.sublabel && (
                                            <span className="custom-control-label__subtitle" dangerouslySetInnerHTML={{ __html: choice.sublabel }} />
                                        )}
                                    </Form.Check.Label>
                                </Form.Check>
                            </div>
                        );
                    })}
                </div>
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
